module.exports = __webpack_public_path__ + "media/images/mast_bkgnd-ac3e243a.png";